var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.6 67.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-111{fill:#474BF5;stroke:#474BF5;stroke-miterlimit:10;stroke-width:6px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    className: "cls-111",
    d: "M83.31,27.48,69.59,14.75,57.16,3.24a.89.89,0,0,0-1.26,0,.86.86,0,0,0-.23.6v9.32A55,55,0,0,0,3,63.68a.53.53,0,0,0,.49.56.51.51,0,0,0,.44-.18c11.53-13.67,30.35-22.73,51.74-23.3v11.6a.89.89,0,0,0,.89.89.91.91,0,0,0,.6-.24L69.3,41.76l14-13a.88.88,0,0,0,0-1.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.cad2cd6b82fd0638acd08e476b69c274.svg";
export { ForwardRef as ReactComponent };